
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M237.997 54.361c-6.901-2.8-14.903-1.3-20.304 4.101L105.271 171.184H18.554A18.57 18.57 0 00-.05 189.788v133.926c0 10.203 8.301 18.504 18.604 18.504h86.217L217.793 455.04c3.601 3.6 8.402 5.401 13.203 5.401 2.4 0 4.801-.5 7.102-1.401 7.001-2.8 11.502-9.601 11.502-17.103V71.464c-.001-7.501-4.602-14.302-11.603-17.103zM431.734 256.2c0-69.514-41.508-132.126-105.621-159.531-9.502-4.001-20.403.3-24.404 9.701-4.102 9.402.3 20.304 9.802 24.305 50.51 21.604 83.116 70.813 83.116 125.424 0 54.411-32.406 103.52-82.716 125.125-9.402 4.101-13.804 15.003-9.702 24.404 3.001 7.001 9.901 11.202 17.204 11.202 2.399 0 4.9-.5 7.301-1.5 63.812-27.505 105.02-89.916 105.02-159.13zm-82.315 0c0-36.708-21.905-69.714-55.911-84.016-9.402-3.901-20.405.4-24.305 9.801-4.102 9.402.3 20.304 9.802 24.305 20.204 8.502 33.105 28.105 33.105 49.91 0 21.504-12.901 41.008-32.806 49.71-9.502 4.101-13.803 15.003-9.702 24.404 3.101 7.001 9.902 11.103 17.104 11.103 2.501 0 5.001-.5 7.401-1.5 33.607-14.604 55.312-47.41 55.312-83.717zm8.301-232.946c-9.502-4.1-20.504.3-24.405 9.702-4.1 9.402.301 20.304 9.802 24.305C423.132 91.468 474.743 169.483 474.743 256.2c0 86.316-51.511 164.232-131.227 198.539-9.501 4.1-13.802 15.003-9.802 24.403 3.101 7.002 9.901 11.203 17.104 11.203 2.5 0 5.001-.5 7.401-1.501C451.538 448.737 511.95 357.42 511.95 256.3c0-101.52-60.512-193.038-154.23-233.046z"}})])
          )
        }
      }
    